import {
  NotificationDTO,
  NotificationTypes,
} from 'containers/notifications/types/notifications'
import { SurfaceType } from 'containers/likes/types/likes'
import { LikeHighlight } from './LikeHighlight'
import { LikeProject } from './LikeProject'
import { NotificationBase } from '../NotificationBase'
import { useNotificationsLikeUserInfo } from 'containers/notifications/hooks/notifications-users'
import { useNotificationTime } from 'containers/notifications/hooks/notification-time'
import { User } from 'containers/user/types/user'

interface NotificationItemProps {
  notification: Extract<NotificationDTO, { notificationType: NotificationTypes.LIKE }>
  onRequestConnection?: (profile: User) => void
}

export const LikeNotification = ({ notification, onRequestConnection }: NotificationItemProps) => {
  const {loading, profileLiker, profileOwner, isUserOwner} = useNotificationsLikeUserInfo(notification)
  const time = useNotificationTime(notification)


  return (
    <NotificationBase
      mainAvatar={profileLiker?.avatar}
      mainUsername={profileLiker?.username}
      secondaryAvatar={!isUserOwner ? profileOwner?.avatar : undefined}
      secondaryUsername={!isUserOwner ? profileOwner?.username : undefined}
      time={time}
      loading={loading}
      >
        <>
          {notification?.specificData?.surfaceType === SurfaceType.HIGHLIGHT ? (
            <LikeHighlight notification={notification} onRequestConnection={onRequestConnection} />
          ) : (
            <LikeProject notification={notification} />
          )}
        </>
    </NotificationBase>
  )
}
